
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaPenNib } from 'react-icons/fa'; // Import icons from react-icons
import '../styles/IndianLawPage.css';

const IndianLaw = () => {
  const navigate = useNavigate();

  return (
    <div className="container">
      {/* Introduction Section */}
      <div className="introduction">
        <h1 className="introduction-title">Indian Judiciary System</h1>
        <p className="introduction-text">
          The Indian judiciary system is an independent and impartial institution, serving as the guardian of the Constitution and the cornerstone of democracy. 
          It is committed to upholding justice, ensuring the rule of law, and protecting the rights of individuals across the nation. 
          With features like an independent judiciary, a unified three-tier structure, and the power of judicial review, 
          it strives to ensure justice, equality, and accountability for all citizens.
        </p>
      </div>

      {/* First row (unprotected) */}
      <div className="row">
        <div className="column" onClick={() => navigate('/constitution')}>
          Indian Constitution
        </div>
        <div className="column" onClick={() => navigate('/news-information')}>
          News and Verdicts
        </div>
      </div>

      {/* Second row (protected) */}
      <div className="row">
        <div className="column" onClick={() => navigate('/criminal-law')}>
          Criminal Law
        </div>
        <div className="column" onClick={() => navigate('/civil-law')}>
          Civil Law
        </div>
      </div>

      {/* Third row (protected) */}
      <div className="row">
        <div className="column" onClick={() => navigate('/Labour-law')}>
        Labour law
        </div>
        <div className="column" onClick={() => navigate('/corporate-law')}>
          Corporate Law
        </div>
      </div>

      {/* Fourth row (protected) */}
      <div className="row">
        <div className="column" onClick={() => navigate('/family-law')}>
          Family Law
        </div>
        <div className="column" onClick={() => navigate('/consumer-law')}>
          Consumer Law
        </div>
      </div>
    </div>
  );
};

export default IndianLaw;
